<template>
  <v-container class="pa-0">
    <base-subheading>Publications</base-subheading>

    <v-row
      align="center"
      class="mb-2"
    >
      <v-col
        class="d-flex"
        cols="12"
      >
        <div class="subheading">
          <ul>
            <li>
              <span class="text-subtitle-1"><b>Zhang, J.</b> (2022). <a href="https://www.ion.org/publications/abstract.cfm?articleID=18328">Lidar-aided Instantaneous GNSS Ambiguity Resolution in Challenging Environments: Theoretical Assessment and Numerical Results.</a> In <em>Proceedings of the 35th international technical meeting of the satellite division of the institute of navigation (ION GNSS+ 2022)</em>, Denver, Colorado, September 2022, pp. 2054-2063.</span>
            </li>
            <li>
              <span class="text-subtitle-1"><b>Zhang, J.</b>, Khodabandeh, A. &amp; Khoshelham, K. (2022). <a href="https://doi.org/10.1088/1361-6501/ac82dd">Centimeter-level positioning by instantaneous lidar-aided GNSS ambiguity resolution.</a> <em>Measurement Science and Technology, 33</em>(11), 115020.</span>
            </li>
            <li>
              <span class="text-subtitle-1"><b>Zhang, J.</b>, Khoshelham, K., &amp; Khodabandeh, A. (2021). <a href="https://doi.org/10.3390/rs13224525">Seamless vehicle positioning by lidar-GNSS integration: standalone and multi-epoch scenarios.</a> <em>Remote Sensing, 13</em>(22), 4525.</span>
            </li>
            <li>
              <span class="text-subtitle-1"><b>Zhang, J.</b>, &amp; Khoshelham, K. (2020). <a href="https://doi.org/10.1111/phor.12328">3D reconstruction of internal wood decay using photogrammetry and sonic tomography.</a> <em>The Photogrammetric Record, 35</em>(171), 357-374.</span>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapState } from 'vuex'

  export default {
    name: 'Publications',

    data: () => ({}),

    computed: {
      ...mapState(['articles']),
    },
  }
</script>
